import React from 'react';

export default function LoadingIndicator({ label = 'Cargando datos...' }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-10">
      <div className="h-10 w-10 rounded-full border-4 border-blue-200 border-t-blue-600 animate-spin" aria-hidden="true" />
      <p className="text-sm text-gray-600 dark:text-gray-300" role="status">
        {label}
      </p>
    </div>
  );
}
